import http from "services/http/httpInstance";
import { authHeader } from "services/http/AuthService";

const url = "/preorders/";

export const httpGetPreorder = (request, preorderId) =>
  http({
    url: url + preorderId + "/",
    method: "GET",
    headers: {
      ...authHeader(),
    },
    ...request,
  });

export const httpGetPreorderDriverReceipt = (preorderId) =>
  http({
    url: url + preorderId + "/get_driver_receipt/?download=1",
    method: "GET",
    responseType: "blob",
    headers: {
      ...authHeader(),
      "content-type": "octet/stream",
    },
  });
